/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
export class PopoverProvider {
    constructor() {
        this.config = {
            animation: true,
            delay: 0,
            html: false,
            placement: 'right',
            title: '',
            content: '',
            trigger: 'click'
        };
    }
    $get() {
        return this.config;
    }
}
